export default __webpack_public_path__ + "static/media/icon_10_v2.d36a4ad8.png";